// extracted by mini-css-extract-plugin
export default {"fadeInUp":"titleAnimation_fadeInUp__XvF3T","show":"titleAnimation_show__LJleC"};